export default "__VITE_ASSET__5wyj1SEx__"